import { render, staticRenderFns } from "./NsRadioGroup.vue?vue&type=template&id=311aff1f&scoped=true&"
import script from "./NsRadioGroup.vue?vue&type=script&lang=js&"
export * from "./NsRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./NsRadioGroup.vue?vue&type=style&index=0&id=311aff1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311aff1f",
  null
  
)

export default component.exports